<template>
  <div id="app">
    <div id="nav">
      <router-link :to="{ name: 'event-list' }">Events</router-link> |
      <router-link :to="{ name: 'event-create' }">Create</router-link> |
      <router-link :to="{ name: 'about' }">About</router-link>
    </div>
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

h4 {
  font-size: 20px;
}
.d-flex {
  display: flex;
}
</style>
